// A LINK THAT HAS BEEN CLICKED SAYS SO UNTIL THE NEXT PAGE ARRIVES.
//
// Every header link is an ordinary navigation, and the browser keeps the old page on screen,
// unchanged, until the server answers with the new one. On a light page that is a blink. On the
// Inbox it is long enough to look as though the click never landed: moving from a shared mailbox
// back to your own Inbox is the same layout both ways, so nothing on screen moved, and people
// clicked again. Clicking again starts the whole load over.
//
// So a same-tab click on a link in the site header marks that link pending and runs a thin progress
// line along the top of the window. Nothing about the navigation itself changes: a modified click,
// a new tab, another site, a link to the page already open or a link another handler took over is
// left alone. The mark clears on `pageshow`, which is also what a Back gesture restoring this page
// from the browser's cache fires, so a restored page never shows a load that already finished.
//
// `PortalNavPending.start(el)` is the same mark for a navigation that is not a link click, such as
// the shared mailbox switcher (public/js/inbox-shared-mailbox.js).
'use strict';
(function () {
  var PENDING = 'portal-nav-pending';
  var bar = null;
  var pendingEl = null;

  function start(el) {
    clear();
    document.documentElement.classList.add(PENDING);
    if (el) {
      pendingEl = el;
      el.classList.add('is-nav-pending');
      el.setAttribute('aria-busy', 'true');
    }
    bar = document.createElement('div');
    bar.className = 'portal-nav-progress';
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-label', typeof window.t === 'function' ? window.t('common.loading') : '');
    document.body.appendChild(bar);
  }

  function clear() {
    document.documentElement.classList.remove(PENDING);
    if (pendingEl) {
      pendingEl.classList.remove('is-nav-pending');
      pendingEl.removeAttribute('aria-busy');
      pendingEl = null;
    }
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    bar = null;
  }

  /** Does this click leave the page for another one, in this tab? */
  function leavesPage(e, link) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (link.hasAttribute('download') || link.hasAttribute('data-on-click')) return false;
    var target = link.getAttribute('target');
    if (target && target !== '_self') return false;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return false; } // why-safe: an unparseable href is not a navigation to mark
    if (url.origin !== window.location.origin) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    // The page already open, or a jump within it: no load follows.
    return !(url.pathname === window.location.pathname && url.search === window.location.search);
  }

  // Bubble phase on the document, so a handler that takes a click over (and prevents it) has
  // already run and is respected.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.site-header a[href]') : null;
    if (!link || !leavesPage(e, link)) return;
    start(link);
  });

  window.addEventListener('pageshow', clear);

  window.PortalNavPending = { start: start, clear: clear };
})();
